module.exports = __webpack_public_path__ + "img/full2-min.37c1f6d6.png";